import React from "react";

import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { Box, Checkbox, Collapse, FormControlLabel, IconButton, Stack, Typography } from "@mui/material";
import { IPortfolioConstructionDealTreeItem } from "store/types";

interface Props {
  item: IPortfolioConstructionDealTreeItem;
  level: number;
  parentPath: string;
  selectedItems: { path: string; type: string; name: string }[];
  onToggle: (path: string, type: string, name: string) => void;
  expandedItems: string[];
  onExpand: (path: string) => void;
}

export const TreeItemCheckbox: React.FC<Props> = ({
  item,
  level,
  parentPath,
  selectedItems,
  onToggle,
  expandedItems,
  onExpand
}) => {
  const currentPath = parentPath ? `${parentPath}/${item.name}` : item.name;
  const isExpanded = expandedItems.includes(currentPath);
  const isSelected = selectedItems.some((selected) => selected.path === currentPath);
  const hasChildren = item.children && item.children.length > 0;

  return (
    <Box>
      <Stack direction="row" alignItems="center" sx={{ pl: level * 8 }}>
        {hasChildren && (
          <IconButton size="sm" onClick={() => onExpand(currentPath)} sx={{ p: 0.5, mr: 0.5 }}>
            <ExpandMoreIcon
              sx={{
                fontSize: "16px",
                transform: isExpanded ? "rotate(0deg)" : "rotate(-90deg)",
                transition: "transform 0.2s"
              }}
            />
          </IconButton>
        )}
        {!hasChildren && <Box sx={{ width: "24px" }} />}
        <FormControlLabel
          control={
            <Checkbox checked={isSelected} onChange={() => onToggle(currentPath, item.type, item.name)} size="small" />
          }
          label={
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              {item.name}
            </Typography>
          }
          sx={{ flex: 1, m: 0 }}
        />
      </Stack>
      {hasChildren && (
        <Collapse in={isExpanded}>
          <Box>
            {item.children!.map((child) => (
              <TreeItemCheckbox
                key={child.id}
                item={child}
                level={level + 1}
                parentPath={currentPath}
                selectedItems={selectedItems}
                onToggle={onToggle}
                expandedItems={expandedItems}
                onExpand={onExpand}
              />
            ))}
          </Box>
        </Collapse>
      )}
    </Box>
  );
};
